// extracted by mini-css-extract-plugin
export default {"customButton":"Button_customButton__DGZhb"};